import { UPDATE_TUTORIAL_ACTIVE_SECTION } from '../actionTypes';

const initialState = {
    sectionId: 'section-tutorialStart',
};

const tutorial = function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_TUTORIAL_ACTIVE_SECTION: {
            const { sectionId } = action.payload;
            if (sectionId === 'section-tutorialStart') console.trace();
            return {
                ...state,
                sectionId,
            };
        }

        default:
            return state;
    }
};
export default tutorial;
 